import React, { PureComponent, Fragment } from 'react';
import { Wrapper, Container, Title, Accordion, AnswerTitle, AnswerText, AnswerList, AnswerItem, Answers } from './styled';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';
import { data } from './data';

const themeForAccordion = {
    border: '#555555',
    background: '#3E3E3E',
    color: COLORS.white,
    colorArrow: COLORS.white,
    backgroundIcon: 'transparent',
    borderIcon: COLORS.white
};

class Questions extends PureComponent {

    renderAnswers = answers => answers.map((answer, index) => {

        const { renderList } = this;

        const { title, text, list } = answer;

        return (
            <Fragment key={index}>
                {title && <AnswerTitle data-test={`answerMainTitle-${index}`}>{title}</AnswerTitle>}
                {text && <AnswerText dangerouslySetInnerHTML={{ __html: text }} />}
                {list && renderList(list, index)}
            </Fragment>
        );
    });

    renderList = (list, index) => {

        const { title, items } = list;

        return (
            <Fragment>
                <AnswerTitle data-test={`answerTitle-${index}`}>{title}</AnswerTitle>
                <AnswerList>{items.map((item, index) => <AnswerItem key={index}>{item}</AnswerItem>)}</AnswerList>
            </Fragment>
        );
    };

    render() {
        const { renderAnswers } = this;

        return (
            <Wrapper ref={node => this.wrapper = node}>
                <Container itemScope itemType='https://schema.org/FAQPage'>
                    <Title data-test='titleQuestions'>Частые вопросы</Title>
                    {
                        data.map((item, index) => (
                            <div
                                key={index}
                                itemScope
                                itemProp='mainEntity'
                                itemType='https://schema.org/Question'
                            >
                                <Accordion
                                    title={item.question}
                                    customTheme={themeForAccordion}
                                    defaultOpen={index === 0}
                                >
                                    <Answers itemProp='text'>
                                        {renderAnswers(item.answers)}
                                    </Answers>
                                </Accordion>
                            </div>
                        ))
                    }
                </Container>
            </Wrapper>
        );
    }
}

export default Questions;
